/**
 * Definiciones de carta: el plano de **diseno**, inmutable durante la partida.
 *
 * Se deriva de la matriz normativa de `GAME_RULES.md` (seccion 8, «Informacion
 * visible minima de una carta»). La matriz no es por si misma este modelo, pero
 * este modelo debe respetarla: cualquier divergencia es un defecto de aqui.
 *
 * Nada de este fichero describe **efectos**. `effectText` es texto opaco: no hay
 * motor de efectos, disparos, pila ni cadenas, y no deben introducirse.
 */
/** Los tres tipos de carta (seccion 8). */
export const CARD_TYPES = ['offer', 'invocation', 'spell'];
/**
 * Marcador para la `Clase` de una Ofrenda mientras 12.27 siga pendiente.
 *
 * Es deliberadamente feo y greppable. **No es una Clase**: es la ausencia de
 * decision hecha explicita, para que ninguna carta finja tener una taxonomia que
 * el diseno no ha fijado. Cuando 12.27 se resuelva, este valor desaparece.
 */
export const UNRESOLVED_CARD_CLASS = 'PENDIENTE_12_27';
/**
 * Clases de Invocacion confirmadas (seccion 8).
 *
 * A diferencia de las Ofrendas, estos valores **si** son normativos. Sigue
 * abierto si la lista es exhaustiva (12.27): si el diseno confirma una tercera
 * Clase, se anade aqui y el compilador senalara todo lo que haya que revisar.
 */
export const INVOCATION_CLASSES = ['undead', 'beast'];
/** Clases de Hechizo. Estas si son normativas (seccion 8). */
export const SPELL_CLASSES = ['immediate', 'permanent'];
/** Subtipos de Hechizo confirmados. `Clima` es subtipo, nunca clase (seccion 8). */
export const SPELL_SUBTYPES = ['climate'];
export function isOfferDefinition(definition) {
    return definition.type === 'offer';
}
export function isInvocationDefinition(definition) {
    return definition.type === 'invocation';
}
export function isSpellDefinition(definition) {
    return definition.type === 'spell';
}
/** Un Clima usa la Zona de Clima compartida en lugar del Campo (seccion 8). */
export function isClimateSpell(definition) {
    return isSpellDefinition(definition) && definition.subtype === 'climate';
}
//# sourceMappingURL=cards.js.map